/**
 * Approved customer-facing copy for CTAs, error titles, and micro-labels.
 *
 * @see docs/UX_COPY_STYLE_GUIDE.md (issue #35)
 * Policy / legal snippets: @see policy-snippets.ts
 */

/** Primary: repeat the last failed action */
export const CTA_TRY_AGAIN = 'Try again';

/** Route to human support */
export const CTA_CONTACT_SUPPORT = 'Contact support';

/** Cart → full checkout page */
export const CTA_PROCEED_CHECKOUT = 'Proceed to checkout';

/** Leave order flow and keep browsing */
export const CTA_CONTINUE_SHOPPING = 'Continue shopping';

/** Cart: below minimum, add items */
export const CTA_BROWSE_MENU = 'Browse menu';

/** Cart: same-day blocked, fulfillment fallback */
export const CTA_SWITCH_MAIL_ORDER = 'Switch to mail order';

/** Recovery: return to step 2 */
export const CTA_REVIEW_ORDER_DETAILS = 'Review order details';

/** Recovery: return to payment step */
export const CTA_REVIEW_PAYMENT_STEP = 'Review payment step';

/** Cart drawer → full checkout for more detail */
export const CTA_OPEN_FULL_CHECKOUT = 'Open full checkout';

/** Copy reference id control */
export const CTA_COPY = 'Copy';

export const CTA_COPIED = 'Copied';

/** In-progress button label */
export const STATUS_BUTTON_RETRYING = 'Retrying…';

/** In-progress headline while onRetry runs */
export const STATUS_RETRY_IN_PROGRESS = 'Retrying…';

/** Error card headings */
export const ERROR_TITLE_ORDER_ISSUE = 'Order issue';

export const ERROR_TITLE_PAYMENT_ISSUE = 'Payment issue';

export const ERROR_TITLE_PROMO = 'Promo code';

export const ERROR_TITLE_CART_CHECKOUT_FAILED = 'Checkout could not be completed';

/** Reference block */
export const MICRO_REFERENCE_ID_LABEL = 'Reference ID';

export const MICRO_REFERENCE_ID_HELPER =
  'Share this ID with our team, no extra details needed.';

export const ARIA_COPY_REFERENCE_ID = 'Copy reference ID';

export const ARIA_DISMISS = 'Dismiss';

/** Marketing / contact tab (hero CTAs) */
export const CTA_SHOP_NOW = 'Shop now';

export const CTA_TRACK_ORDER = 'Track order';

export const CTA_CONTACT_TEAM = 'Contact team';

/** Product line items */
export const CTA_ADD_TO_CART = 'Add to cart';

export const STATUS_OUT_OF_STOCK = 'Out of stock';

/** Account / auth */
export const CTA_SIGN_IN = 'Sign in';

export const STATUS_SIGNING_IN = 'Signing in…';

/** Order history */
export const CTA_VIEW_ALL_ORDERS = 'View all orders';
